enum UserRoles {
  SuperAdmin = 'SuperAdmin',
  GroupAdmin = 'GroupAdmin',
  MonitoringEngineer = 'Monitoring',
}

export default UserRoles;
